(function () {
  const STORAGE_KEY = 'saglikli-goz-session-popup-dismissed';
  const SHOW_DELAY_MS = 1000;
  const FADE_DURATION_MS = 350;

  /** @type {MediaQueryList | undefined} */
  const reducedMotionQuery =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : undefined;

  /**
   * @param {HTMLDialogElement} popupDialog
   */
  function showPopupWithFade(popupDialog) {
    popupDialog.classList.remove('custom-session-popup__dialog--closing');

    if (reducedMotionQuery?.matches) {
      popupDialog.classList.add('custom-session-popup__dialog--shown');
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popupDialog.classList.add('custom-session-popup__dialog--shown');
      });
    });
  }

  /**
   * @param {HTMLElement} popupRoot
   * @param {HTMLDialogElement} popupDialog
   * @param {() => void} onComplete
   */
  function hidePopupWithFade(popupRoot, popupDialog, onComplete) {
    if (!popupDialog.open) {
      onComplete();
      return;
    }

    if (reducedMotionQuery?.matches) {
      popupDialog.close();
      popupDialog.classList.remove('custom-session-popup__dialog--shown', 'custom-session-popup__dialog--closing');
      popupRoot.hidden = true;
      onComplete();
      return;
    }

    popupDialog.classList.remove('custom-session-popup__dialog--shown');
    popupDialog.classList.add('custom-session-popup__dialog--closing');

    /** @type {HTMLElement | null} */
    const panel = popupRoot.querySelector('.custom-session-popup__panel');
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;

      if (popupDialog.open) {
        popupDialog.close();
      }

      popupDialog.classList.remove('custom-session-popup__dialog--closing');
      popupRoot.hidden = true;
      onComplete();
    };

    if (panel instanceof HTMLElement) {
      panel.addEventListener(
        'transitionend',
        (event) => {
          if (event.target === panel && event.propertyName === 'opacity') {
            finish();
          }
        },
        { once: true }
      );
    }

    window.setTimeout(finish, FADE_DURATION_MS + 80);
  }

  function initSessionPopup() {
    const rootNode = document.querySelector('[data-session-popup]');
    if (!(rootNode instanceof HTMLElement)) return;

    const dialogNode = rootNode.querySelector('.custom-session-popup__dialog');
    if (!(dialogNode instanceof HTMLDialogElement)) return;

    /** @type {HTMLElement} */
    const popupRoot = rootNode;
    /** @type {HTMLDialogElement} */
    const popupDialog = dialogNode;

    const designMode = popupRoot.dataset.designMode === 'true';

    if (!designMode && sessionStorage.getItem(STORAGE_KEY) === '1') {
      return;
    }

    let isClosing = false;

    function dismiss() {
      if (isClosing) return;

      if (!designMode) {
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (error) {
          console.error(error);
        }
      }

      isClosing = true;

      hidePopupWithFade(popupRoot, popupDialog, () => {
        isClosing = false;
      });
    }

    popupRoot.querySelectorAll('[data-session-popup-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        dismiss();
      });
    });

    popupDialog.addEventListener('click', (event) => {
      if (event.target === popupDialog) {
        dismiss();
      }
    });

    popupDialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });

    const link = popupRoot.querySelector('[data-session-popup-link]');
    if (link instanceof HTMLAnchorElement) {
      link.addEventListener('click', () => {
        if (!designMode) {
          try {
            sessionStorage.setItem(STORAGE_KEY, '1');
          } catch (error) {
            console.error(error);
          }
        }
      });
    }

    window.setTimeout(() => {
      if (!designMode && sessionStorage.getItem(STORAGE_KEY) === '1') {
        return;
      }

      popupRoot.hidden = false;

      if (popupDialog.open) {
        return;
      }

      try {
        popupDialog.showModal();
        showPopupWithFade(popupDialog);
      } catch (error) {
        console.error(error);
      }
    }, SHOW_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSessionPopup);
  } else {
    initSessionPopup();
  }
})();
